import styled from 'styled-components';
import { Body2 } from 'ui/theme';

export const OptionsContainer = styled.div`
  border: ${({ theme }) => `1px solid ${theme.colors.neutrals.grey5}`};
  border-radius: ${({ theme }) => theme.spacing.values.quarter};
  & > div:not(:last-child) {
    border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutrals.grey5}`};
  }
  margin-bottom: ${({ theme }) => theme.spacing.values.plusHalf};
`;
export const OptionsRow = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: ${({ theme }) =>
    `${theme.spacing.utils.pxToRem(40)} 3fr ${theme.spacing.utils.pxToRem(20)}`};
  align-items: center;
  margin-left: 1rem;
  padding: ${({ theme }) =>
    `${theme.spacing.values.base} ${theme.spacing.values.base} ${theme.spacing.values.base} 0`};
`;
export const ChannelIcon = styled.div``;
export const ChannelText = styled(Body2)`
  margin: 0;
`;
